import { render, staticRenderFns } from "./FormCreateMetaDataField.vue?vue&type=template&id=4fd85efa&"
import script from "./FormCreateMetaDataField.vue?vue&type=script&lang=js&"
export * from "./FormCreateMetaDataField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports